// extracted by mini-css-extract-plugin
export var centerText = "_51-8";
export var container = "_51-0";
export var doughnutContainer = "_51-7";
export var legend = "_51-a";
export var legendItemColorDisplay = "_51-b";
export var legendItemLabel = "_51-d";
export var legendItemValue = "_51-c";
export var lg = "_51-5";
export var maxWidth = "_51-9";
export var md = "_51-4";
export var responsive = "_51-6";
export var sm = "_51-3";
export var xs = "_51-2";
export var xxs = "_51-1";